import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import ProgressBar from './ProgressBar';
import ProgressBarMini from './ProgressBarMini';
import { useOptions } from '../../../OptionsContext';
import {
  selectIsSeekEnabled,
  selectNormalizedInterval,
  selectNormalizedCurrentTime,
} from '../../../selectors';

function ProgressBarContainer() {
  const { mini } = useOptions();
  const seekEnabled = useSelector(selectIsSeekEnabled);

  const {
    isPlayingAds,
    isAirPlaying,
    viewableMetadata,
    playing,
    controlsVisible,
  } = useSelector(({ playback, controls }) => ({
    isPlayingAds: playback.isPlayingAds,
    isAirPlaying: playback.isAirPlaying,
    viewableMetadata: playback.viewableMetadata,
    playing: playback.playing,
    controlsVisible: controls.controlsVisible,
  }), shallowEqual);

  const [,, duration] = useSelector(selectNormalizedInterval, shallowEqual);
  const currentTime = useSelector(selectNormalizedCurrentTime);
  const progress = Number(Math.min(currentTime / (duration || 1), 1).toFixed(3));

  if (mini) {
    return (
      <ProgressBarMini
        isPlayingAds={isPlayingAds}
        isAirPlaying={isAirPlaying}
        progress={progress}
        seekEnabled={seekEnabled}
      />
    );
  }

  return (
    <ProgressBar
      isPlayingAds={isPlayingAds}
      isAirPlaying={isAirPlaying}
      controlsVisible={controlsVisible}
      isLiveEvent={viewableMetadata.isLiveEvent}
      playing={playing}
      seekEnabled={seekEnabled}
      progress={progress}
      duration={duration}
    />
  );
}

export default React.memo(ProgressBarContainer);
